import * as CoreContextActions from './core-context-actions';
import { CoreContextActionTypes } from './core-context-actions';
import { Settings } from '@app/core/_models/settings';
import { Action } from '@ngrx/store';

export interface State {
  settings: Settings | null;
  settingsHandled: boolean;
  cookieTrackingConsent: boolean | null;
  currentLanguage: string | null; // TODO
}

const initialState: State = {
  settings: null,
  settingsHandled: false,
  cookieTrackingConsent: null,
  currentLanguage: null,
};

export function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT: {
      return {
        ...state,
        cookieTrackingConsent: (<CoreContextActions.SetCookieTrackingConsent>action).enabled,
      };
    }
    case CoreContextActionTypes.SETTINGS_LOADED: {
      return {
        ...state,
        settings: (<CoreContextActions.SettingsLoaded>action).settings,
        settingsHandled: true,
      };
    }
    default: { return state; }
  }
}
